import React from "react";
import RatingStars from "../common/RatingStars";

const ReviewSummary = ({ rating, count }) => {
  const rows = [5, 4, 3, 2, 1].map((stars) => ({ stars, percent: stars === 5 ? 82 : stars === 4 ? 13 : stars === 3 ? 3 : 1 }));
  return (
    <section className="review-summary" aria-labelledby="review-summary-title">
      <div className="review-summary__score">
        <p className="eyebrow">Customer reviews</p>
        <h2 id="review-summary-title">Cook-approved flavor</h2>
        <strong>{rating.toFixed(1)}</strong>
        <RatingStars rating={rating} count={count} />
        <p>Based on {count} verified pantry reviews.</p>
      </div>
      <div className="review-summary__histogram">
        {rows.map((row) => (
          <div key={row.stars}><span>{row.stars} stars</span><span className="review-summary__bar"><span style={{ width: `${row.percent}%` }} /></span><small>{row.percent}%</small></div>
        ))}
      </div>
      <blockquote>
        “Bright, fresh, and exactly as described. The flavor notes make it easy to reach for this jar on a weeknight.”
        <footer>— Jamie L., verified customer</footer>
      </blockquote>
    </section>
  );
};

export default ReviewSummary;
